import { HttpError } from "@/dashboard/lib/api/errors";

export async function fetchJson<T>(url: string, init?: RequestInit): Promise<T> {
  const res = await fetch(url, {
    credentials: "include", // always include cookies
    headers: { "Content-Type": "application/json" },
    ...init,
  });

  if (!res.ok) {
    let msg = `Request failed (${res.status})`;
    try {
      const { error } = (await res.json()) as { error?: unknown };
      if (typeof error === "string") {
        msg = error;
      }
    } catch {
      // swallow
    }

    throw new HttpError(res.status, msg);
  }

  // 204 No Content → return undefined
  return (res.status === 204 ? undefined : await res.json()) as T;
}
